import cx from 'classnames';
import { DateTime } from 'luxon';
import { Text } from '../../components/Text';

interface AgentsDayHeadersProps {
  days: DateTime[];
  agentCount: number;
}

export const AgentsDayHeaders: React.FC<AgentsDayHeadersProps> = ({
  days,
  agentCount,
}) => (
  <>
    <div className="border-b mb-4 sticky top-14 lg:top-20 bg-white pt-4 flex items-center">
      <Text.Small className="py-2">Showing {agentCount} Agents</Text.Small>
    </div>
    {days.map((day, index) => (
      <div
        key={day.toISODate()}
        className={cx(
          'flex-col items-center justify-end border-b mb-4 sticky top-14 lg:top-20 bg-white pt-4',
          'hidden xl:flex',
          {
            'md:flex': index < 3,
            'sm:flex': index < 2,
          },
        )}
      >
        <div>
          {index === 0 ? (
            <div className="uppercase font-semibold text-sm">Today</div>
          ) : null}
          <span className="text-gray-500 font-medium mr-2">
            {day.toLocaleString({ day: '2-digit' })}
          </span>
          <strong className="font-semibold">
            {day.toLocaleString({ weekday: 'short' })}
          </strong>
        </div>
      </div>
    ))}
  </>
);
